export default class SiteNav {
  constructor($el) {
    this.$el = $($el)
    this.activeClass = 'is-dropdown-open'
    this.dropdown = '.c-site-nav__dropdown'

    $(this.dropdown)
      .parent()
      .addClass('has-dropdown')

    const $dropdownParent = this.$el.find('.has-dropdown')

    this.handleEvent($dropdownParent)
  }

  handleEvent($element) {
    $element.on('mouseenter', e => {
      this.mouseEnter(e.currentTarget)
    })

    $element.on('mouseleave', () => {
      this.mouseLeave()
    })
  }

  mouseEnter(target) {
    const dropdownHeight = $(target)
      .find(this.dropdown)
      .outerHeight()
    $('.c-site-nav__mask').css('height', dropdownHeight)

    this.$el.add($('.c-site-header')).addClass(this.activeClass)
  }

  mouseLeave() {
    this.$el.add($('.c-site-header')).removeClass(this.activeClass)
    $('.c-site-nav__mask').css('height', '0px')
  }
}
